import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Layer as MapboxLayer } from 'react-mapbox-gl';

class Layer extends React.Component {
    static propTypes = {
        styling: PropTypes.object.isRequired
        // All default mapbox layer props
    };

    constructor (props) {
        super(props);
    }

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        if (!_.isEqual(this.props, nextProps)) {
            return true;
        }
        return false;
    }

    render () {
        const { styling, ...otherProps } = this.props;

        return (
            <MapboxLayer
                {...styling}
                {...otherProps}
            />
        );
    }
}

export default Layer;